import { field, formatUnits, parseEther, readContract, toBool, writeContractAndWait } from "../viem";

import MafiaRouletteAbi from "../../abis/MafiaRoulette.json";
import config from "../../config/config";
import { Roulette } from "../../types/Contract/Roulette/Roulette";
import { RouletteBet } from "../../types/Contract/Roulette/RouletteBet";
import { RouletteBetInfo } from "./../../types/Contract/Roulette/RouletteBetInfo";

const address = config.rouletteAddress;
const abi = MafiaRouletteAbi;

export const depositLiquidity = async (
  account: string,
  rouletteId: number,
  amount: number
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "depositLiquidity",
    args: [rouletteId, parseEther(amount.toString())],
    account,
  });

  return data;
};

export const removeLiquidity = async (
  account: string,
  rouletteId: number,
  amount: number
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "removeLiquidity",
    args: [rouletteId, parseEther(amount.toString())],
    account,
  });

  return data;
};

export const updateRouletteSettings = async (
  account: string,
  rouletteId: number,
  // isOpened: boolean,
  minBet: number,
  maxBet: number,
  message: string,
  signature: string
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "updateRouletteSettings",
    args: [
      rouletteId,
      parseEther(minBet.toString()),
      parseEther(maxBet.toString()),
      JSON.stringify(message),
      signature,
    ],
    account,
  });

  return data;
};

export const initializeBet = async (
  account: string,
  rouletteId: number,
  bets: RouletteBet[],
  signature: string,
  message: string
) => {
  console.log(
    rouletteId,
    bets.map((bet) => {
      return {
        ...bet,
        amount: parseEther(bet.amount.toString()),
      };
    }),
    JSON.stringify(message),
    signature
  );
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "initializeBet",
    args: [
      rouletteId,
      bets.map((bet) => {
        return {
          ...bet,
          amount: parseEther(bet.amount.toString()),
        };
      }),
      JSON.stringify(message),
      signature,
    ],
    account,
  });

  return data;
};

export const finishBet = async (account: string, rouletteId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "finishBet",
    args: [rouletteId],
    account,
  });

  return data;
};

export const cancelBet = async (account: string, rouletteId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "cancelBet",
    args: [rouletteId],
    account,
  });

  return data;
};

export const getRouletteLiquidity = async (
  rouletteId: number,
  message: string,
  signature: string
) => {
  const liquidity: number = await readContract({
    address,
    abi,
    functionName: "getRouletteLiquidity",
    args: [rouletteId, JSON.stringify(message), signature],
  });

  return parseInt(formatUnits(liquidity, 18));
};

export const getRoulettes = async () => {
  const roulettes: any[] = await readContract({
    address,
    abi,
    functionName: "getRoulettes",
  });

  const parsedRoulettes: Roulette[] = roulettes.map((roulette: any) => {
    return {
      id: Number(field(roulette, "id", 0)),
      isOpened: field(roulette, "isOpened", 1),
      minBet: parseInt(formatUnits(field(roulette, "minBet", 4), 18)),
      maxBet: parseInt(formatUnits(field(roulette, "maxBet", 3), 18)),
      minBetBottom: parseInt(formatUnits(field(roulette, "minBetBottom", 6), 18)),
      minBetTop: parseInt(formatUnits(field(roulette, "minBetTop", 5), 18)),
      maxBetBottom: parseInt(formatUnits(field(roulette, "maxBetBottom", 8), 18)),
      maxBetTop: parseInt(formatUnits(field(roulette, "maxBetTop", 7), 18)),
      ownedAt: Number(field(roulette, "ownedAt", 2)),
      feesPaid: parseInt(formatUnits(field(roulette, "feesPaid", 9), 18)),
      inventoryItemId: Number(field(roulette, "inventoryItemId", 10)),
      profit: parseInt(formatUnits(field(roulette, "profit", 11), 18)),
    } as Roulette;
  });

  return parsedRoulettes;
};

export const getUserBetInfo = async (account: string, rouletteId: number) => {
  const betInfo: RouletteBetInfo = await readContract({
    address,
    abi,
    functionName: "userBetInfo",
    args: [account, rouletteId],
    account,
    useWallet: true,
  });

  return {
    isPending: toBool(field(betInfo, "isPending", 0)),
    requestBlock: Number(field(betInfo, "requestBlock", 1)),
    totalAmount: field(betInfo, "totalAmount", 2),
  } as RouletteBetInfo;
};
